import enMessages from './src/intl/messages/en_US.json';
import nbMessages from './src/intl/messages/nb_NO.json';
import nnMessages from './src/intl/messages/nn_NO.json';

export const nyUttaksplanMessages = {
    nb: nbMessages,
    nn: nnMessages,
    en: enMessages,
};

export { UttaksplanDataProvider } from './src/context/UttaksplanDataContext';
export { UttaksplanRedigeringProvider } from './src/context/UttaksplanRedigeringContext';

export { UttaksplanListe } from './src/liste/UttaksplanListe';
export { KvoteOppsummering } from './src/KvoteOppsummering';
export { UttaksplanKalender } from './src/kalender/UttaksplanKalender';

export { HvaErMulig } from './src/infobokser/hva-er-mulig/HvaErMulig';
export { UforutsetteEndringer } from './src/infobokser/uforutsette-endringer/UforutsetteEndringer';

export { FjernAltIUttaksplanModal } from './src/FjernAltIUttaksplanModal';
export { TilbakestillPlanModal } from './src/TilbakestillPlanModal';
export { useErAntallDagerOvertrukketIUttaksplan } from './src/utils/kvoteOppsummeringUtils';
export { UttaksperiodeValidatorer } from './src/utils/UttaksperiodeValidatorer';
export { skalBesvareFlerbarnsdager } from './src/utils/flerbarnsdager';
export {
    sorterUttakPerioder,
    harPeriodeDerMorsAktivitetIkkeErValgt,
    harPeriodeMedUkjentGraderingsaktivitet,
    getAntallUttaksdagerIVinduRundtFødsel,
    finnAntallTidelerÅTrekke,
    erPerioderEkslFomTomLike,
} from './src/utils/periodeUtils';
export { prosesserPerioderForVisning } from './src/utils/prosesserPerioderForVisning';
export { deltUttak } from './src/utils/forslag/deltUttak';
export { ikkeDeltUttak } from './src/utils/forslag/ikkeDeltUttak';
